class custonCollection extends HTMLElement {
    constructor() {
        super();
        this.tabItems = this.querySelectorAll('[js-single-collection-tab]');
        this.collectionGrid = this.querySelector('[js-single-collection-grid]');
        this.tabItems.forEach( tabItem => tabItem.addEventListener("click", this.renderCollection.bind(this)));
        this.init();
    }
    init() {
        this.paginationItems = this.querySelectorAll("[js-pagination-item]");
        this.paginationItems.forEach( pagination => pagination.addEventListener("click", this.renderPagination.bind(this)));
    }
    renderPagination(evt) {
        evt.preventDefault();
        const { currentTarget } = evt;
        const url = currentTarget.href;
        this.updateLoading(true);
        this.updateCollection(url);
        
    }

    renderCollection ({currentTarget}) {
        const handle = currentTarget.getAttribute('data-collection-handle');
        if (!handle) return;
        const isTryNow = this.dataset.isTrynow === "true";
        const view = isTryNow ? "trynowajax" : "ajax";
        const url = `/collections/${handle}?view=${view}`;
        this.updateLoading(true);
        this.updateCollection(url);
        this.updateStatus(currentTarget)
    }

    
    updateStatus(target) {
        this.tabItems.forEach( tabItem => tabItem.classList.remove('active'));
        target.classList.add("active");
    }
    updateLoading(isLoading) {
        isLoading ? this.collectionGrid.classList.add("loading") : this.collectionGrid.classList.remove("loading");
    }
    // updateCollection(url) {
    //     fetch(url)
    //     .then((response) => response.text())
    //     .then((html) => {
    //         const doc = new DOMParser().parseFromString(html, 'text/html');
    //         this.collectionGrid.innerHTML = doc.querySelector("[js-single-collection-grid]").innerHTML;
    //         this.init();
    //         document.dispatchEvent(new CustomEvent('collecton-card-slider:init'));
    //     })
    //     .finally(() => {
    //         this.updateLoading(false);
    //     })
    // }
    updateCollection(url) {
      fetch(url)
          .then((response) => response.text())
          .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this.collectionGrid.innerHTML = doc.querySelector("[js-single-collection-grid]").innerHTML;
  
          this.init();
          document.dispatchEvent(new CustomEvent('collecton-card-slider:init'));
  
          const offset = 300; 
          const gridTop = this.collectionGrid.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: gridTop - offset, behavior: 'smooth' });
          })
          .finally(() => {
          this.updateLoading(false);
          });
      }
}
customElements.define('custom-collection', custonCollection);